import { Types } from "../actionTypes";

export const initialState = {
  categoryNav: {
    current: {
      id: "",
      name: "",
    },
  },
};

function categoryNav(state = initialState, action) {
  switch (action.type) {
    case Types.SET_CURRENT_NAV:
      return {
        categoryNav: {
          current: {
            id: action.payload.id,
            name: action.payload.name,
          },
        },
      };
    case Types.RESET_CURRENT_NAV:
      return {
        ...initialState,
      };
    default:
      return state;
  }
}

export const getCurrentNav = (state) => state.categoryNav.current;

export default categoryNav;
